import { RouterService } from './../../../services/router/router.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//Services
import { CredentialsService } from 'src/app/services/credentials/credentials.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { OrderTicketPage } from '../order-ticket/order-ticket.page';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.page.html',
  styleUrls: ['./order-detail.page.scss'],
})
export class OrderDetailPage implements OnInit {
  orderId: string;
  pointsName: string = 'points';
  order: any;
  loader: boolean;
  deliveries: any = [];

  constructor(
    private route: ActivatedRoute,
    private credentialsService: CredentialsService,
    public languageService: LanguagesService,
    private router: RouterService,
    private orderService: OrdersService
  ) {}

  ngOnInit() {
    this.checkParam();
  }
  async checkParam() {
    const param = this.route.snapshot.paramMap.get('id');
    this.orderId = param;
    this.order = await this.orderService.getOrderById(this.orderId);
    if (this.order) {
      this.loader = true;
      this.order.deliveries.map((deliverie) => {
        if (!deliverie.state) {
          deliverie.state = 'processing';
        }
        this.deliveries.push(deliverie);
      });
    } else {
      console.log('error consultando orden', this.order);
      this.loader = false;
    }
  }
  credentialsOrders = () => {
    return this.credentialsService.orders();
  };

  viewTicket() {
    const ticket =
      this.order.deliveries[0].successpuntoredRecaudoMessage.ticked;
    this.router.openPopup(OrderTicketPage, '_', {
      ticket: ticket,
      orden: this.order.deliveries[0].deliveryGlobalId,
    });
  }

  get getTextIUOrdersDetail() {
    return this.languageService.textsIU.page_orders_detail;
  }

  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }
}
